import cn from "classnames"

import { Alert, Flex, Modal, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./ReviewKaiGuidanceModal.module.scss"

import type { ReviewKaiGuidanceModalProps } from "."

export const ReviewKaiGuidanceModal = (props: ReviewKaiGuidanceModalProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings.kai-guidance.refinedGuidanceModal"
  })
  const { open, onOk, onCancel, canonicalText, guidanceText, afterOpenChange } =
    props
  const isOpen = open && !!guidanceText && !!canonicalText

  return (
    <Modal
      mask={{ closable: false }}
      open={isOpen}
      width={550}
      title={t("title")}
      className={styles.modal}
      cancelText={t("cancel")}
      okText={t("ok")}
      onOk={onOk}
      onCancel={onCancel}
      afterOpenChange={afterOpenChange}
    >
      <Flex vertical gap={10}>
        <Text>{t("description")}</Text>
        {["your", "refined"].map((key) => {
          const isRefined = key === "refined"

          return (
            <Alert
              key={key}
              banner
              showIcon={false}
              className={cn(styles.alert, {
                [styles.refined]: isRefined
              })}
              type="info"
              title={t(key)}
              description={isRefined ? canonicalText : guidanceText}
            />
          )
        })}
      </Flex>
    </Modal>
  )
}
